enum SearchEvents {
    SearchStarted = "[Search] SearchStarted",
    SearchCompleted = "[Search] SearchCompleted",
}

export default SearchEvents;
